function menuSidebarMobile() {

    // --- Open Menu ---
    $(document).on('click', '.mobileMenu-toggle', function(event) {
        event.preventDefault();
        $('body').addClass('menu_open');

        if (window.mobile_menu == 'default') {
            if (!$('#navigation-mobile .site-nav-mobile.nav .header__inline-menu').length) {
                $('.header .header__inline-menu').appendTo('#navigation-mobile .site-nav-mobile.nav');
            }
        }
        if (!$('#navigation-mobile .site-nav-mobile.nav-account .free-shipping-text').length) {
            $('.header-top--wrapper .header-top--right .free-shipping-text').appendTo('#navigation-mobile .site-nav-mobile.nav-account .wrapper-links');
        }
        if (!$('#navigation-mobile .site-nav-mobile.nav-account .customer-service-text').length) {
            $('.header-top--wrapper .header-top--right .customer-service-text').appendTo('#navigation-mobile .site-nav-mobile.nav-account .wrapper-links');
        }
        if (!$('#navigation-mobile .site-nav-mobile.nav-account .header__location').length) {
            $('.header-top--wrapper .header-top--right .header__location').appendTo('#navigation-mobile .site-nav-mobile.nav-account .wrapper-links');
        }
        if (!$('#navigation-mobile .top-language-currency').length) {
            if ($('.header').hasClass('header-03')) {
                $('.header .header-bottom-right .top-language-currency').appendTo('#navigation-mobile .site-nav-mobile.nav-currency-language');
            } else if ($('.header').hasClass('header-05')) {
                $('.header .header-top--left .top-language-currency').appendTo('#navigation-mobile .site-nav-mobile.nav-currency-language');
            } else {
                $('.header .header-language_currency .top-language-currency').appendTo('#navigation-mobile .site-nav-mobile.nav-currency-language');
            }
        }
    });

    // --- Toggle Submenu Open (drill-down) ---
    $(document).on('click', '#navigation-mobile [data-toggle-menu-mb]', function(event) {
        event.preventDefault();
        event.stopPropagation();

        // For dropdown menus: parent is .menu-lv-item.dropdown
        var $menuItem = $(this).closest('.menu-lv-item.dropdown');
        if ($menuItem.length) {
            $menuItem.addClass('is-open');
            return;
        }

        // For megamenus: parent is .site-nav.dropdown or .site-nav-list-dropdown
        var $siteNav = $(this).closest('.site-nav.dropdown, .site-nav-list-dropdown');
        if ($siteNav.length) {
            $siteNav.addClass('is-open');
            return;
        }
    });

    // --- Back Button (nav-title-mobile) ---
    $(document).on('click', '#navigation-mobile .nav-title-mobile', function(event) {
        event.preventDefault();
        event.stopPropagation();

        // For dropdown menus: walk up to the submenu wrapper, then to its parent menu item
        var $submenu = $(this).closest('.menu-lv__dropdownmenu');
        if ($submenu.length) {
            var $parentItem = $submenu.parent('.menu-lv-item');
            if ($parentItem.length) {
                $parentItem.find('.menu-lv-item.is-open').removeClass('is-open');
                $parentItem.removeClass('is-open');
            }
            return;
        }

        // For megamenus: walk up to .menu-dropdown, then to its parent .menu-lv-item
        var $megaDropdown = $(this).closest('.menu-dropdown');
        if ($megaDropdown.length) {
            var $parentMega = $megaDropdown.closest('.menu-lv-item.dropdown');
            if ($parentMega.length) {
                $parentMega.find('.is-open').removeClass('is-open');
                $parentMega.removeClass('is-open');
            }
            return;
        }

        // For sub-level back in megamenus (.site-nav-sub): walk up to parent .site-nav
        var $siteNavSub = $(this).closest('.site-nav-sub');
        if ($siteNavSub.length) {
            var $parentSiteNav = $siteNavSub.closest('.site-nav.dropdown, .site-nav-list-dropdown');
            if ($parentSiteNav.length) {
                $parentSiteNav.find('.is-open').removeClass('is-open');
                $parentSiteNav.removeClass('is-open');
            }
            return;
        }

        // For disclosure menus (.list-menu--disclosure): walk up to parent .menu-lv-item
        var $disclosure = $(this).closest('.list-menu--disclosure');
        if ($disclosure.length) {
            var $parentDisclosure = $disclosure.closest('.menu-lv-item.dropdown');
            if ($parentDisclosure.length) {
                $parentDisclosure.find('.is-open').removeClass('is-open');
                $parentDisclosure.removeClass('is-open');
            }
            return;
        }
    });

    // --- Close Menu (X button or overlay) ---
    $(document).on('click', '.halo-sidebar-close, .background-overlay', function(event) {
        event.preventDefault();
        event.stopPropagation();

        // 1. Remove all open submenu states immediately
        $('#navigation-mobile .is-open').removeClass('is-open');

        // 2. Remove menu_open class from body (triggers CSS slide-out transition)
        $('body').removeClass('menu_open');

        // 3. Restore elements back to the desktop header after a delay
        //    Use setTimeout to allow the CSS close transition to complete
        //    (var(--duration-default) is typically 200-300ms, we use 350ms to be safe)
        setTimeout(function() {
            if ($('body').hasClass('menu_open')) return; // User re-opened, bail out

            if (!$('.header .header__inline-menu').length) {
                if ($('.header').hasClass('header-03') || $('.header').hasClass('header-04') || $('.header').hasClass('header-07') || $('.header').hasClass('header-08')) {
                    $('#navigation-mobile .site-nav-mobile.nav .header__inline-menu').appendTo('.header .header-bottom--wrapper .header-bottom-left');
                } else {
                    $('#navigation-mobile .site-nav-mobile.nav .header__inline-menu').appendTo('.header .header-bottom--wrapper');
                }
            }
            if (!$('.header-top--wrapper .header-top--right .free-shipping-text').length) {
                if (!$('.header-04').hasClass('style_2')) {
                    $('#navigation-mobile .site-nav-mobile.nav-account .free-shipping-text').insertBefore('.header-top--wrapper .header-top--right .header__group');
                }
            }
            if (!$('.header-top--wrapper .header-top--right .header__location').length) {
                $('#navigation-mobile .site-nav-mobile.nav-account .header__location').insertBefore('.header-top--wrapper .header-top--right .header__group');
            }
            if (!$('.header-top--wrapper .header-top--right .customer-service-text').length) {
                if ($('.header').hasClass('header-03')) {
                    $('#navigation-mobile .site-nav-mobile.nav-account .customer-service-text').insertBefore('.header-top--wrapper .header-top--right .header__group .header__icon--wishlist');
                } else {
                    $('#navigation-mobile .site-nav-mobile.nav-account .customer-service-text').insertBefore('.header-top--wrapper .header-top--right .top-language-currency');
                }
            }
            if (!$('.header-language_currency .top-language-currency').length) {
                if ($('.header').hasClass('header-03')) {
                    $('#navigation-mobile .site-nav-mobile .top-language-currency').appendTo('.header .header-bottom--wrapper .header-bottom-right .header-language_currency');
                } else if ($('.header').hasClass('header-04')) {
                    $('#navigation-mobile .site-nav-mobile .top-language-currency').appendTo('.header .header-bottom--wrapper .header-bottom-right .header-language_currency');
                } else if ($('.header').hasClass('header-05')) {
                    $('#navigation-mobile .site-nav-mobile .top-language-currency').appendTo('.header .header-top--wrapper .header-top--left .header-language_currency');
                } else {
                    $('#navigation-mobile .site-nav-mobile .top-language-currency').insertBefore('.header .header-language_currency .header__search');
                }
            }
        }, 350);
    });
}

menuSidebarMobile();